interface RegExpConstructor {
  escape: (val: string) => RegExp;
}

RegExp.escape = (val: string) => {
  return new RegExp(val.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'));
}